import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaStepper from './VaStepper.vue'

export const VaStepper = withConfigTransport(_VaStepper)
